<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <h1>
                                Manage Account Numbers Month Wise
                                <button type="button" class="button" @click="addNewYear" style="float: right;">Add New Year</button>
                            </h1>
                        </div>
<!--                         
                        <div class="card-footer">
                            <button type="button" class="button" @click="updateMonthlyAccounts">Update Monthly Accounts</button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4" v-for="(accountYear, index) in yearlyAccounts" :key="index">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4>
                            Year: {{ accountYear.year }}
                            <template v-if="index >=1">
                                <button type="button" class="btn btn-danger" @click="removeYear(index)" style="float: right;">Remove Year</button>
                            </template>
                        </h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                  <label for="" class="form-label">Year</label>
                                  <input type="text"
                                    class="form-control" 
                                    name="" 
                                    id=""
                                    v-model="accountYear.year" 
                                    aria-describedby="helpId" 
                                    placeholder="Year">
                                </div>
                            </div>
                        </div>
                        <hr />
                       <div class="row">
                            <div class="col-md-3 mt-2" v-for="(monthaccount, index) in accountYear.accounts" :key="index">
                                <div class="form-group">
                                  <label for="" class="form-label">{{ monthaccount.month }}</label>
                                  <input type="number"
                                    class="form-control" 
                                    name="" id="" 
                                    :placeholder="`${monthaccount.month} Account Number`"
                                    v-model="monthaccount.accountNumber">
                                </div>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-4">
                <button type="button" class="button" @click="updateMonthlyAccounts">Update Monthly Accounts</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MonthlyAccounts',  
    data() {
        return {
            yearlyAccounts: [this.getDefaultData()]
        };
    },  
    mounted() {
        this.getYearlyAccounts()
    },
    methods: {
        getDefaultData() {
            return {
                year: '',
                accounts: [
                    {
                        id: '01',
                        month: 'January',
                        accountNumber: ''
                    },
                    {
                        id: '02',
                        month: 'February',
                        accountNumber: ''
                    },
                    {
                        id: '03',
                        month: 'March',
                        accountNumber: ''
                    },
                    {
                        id: '04',
                        month: 'April',
                        accountNumber: ''
                    },
                    {
                        id: '05',
                        month: 'May',
                        accountNumber: ''
                    },
                    {
                        id: '06',
                        month: 'June',
                        accountNumber: ''
                    },
                    {
                        id: '07',
                        month: 'July',
                        accountNumber: ''
                    },
                    {
                        id: '08',
                        month: 'August',
                        accountNumber: ''
                    },
                    {
                        id: '09',
                        month: 'September',
                        accountNumber: ''
                    },
                    {
                        id: 10,
                        month: 'October',
                        accountNumber: ''
                    },
                    {
                        id: 11,
                        month: 'November',
                        accountNumber: ''
                    },
                    {
                        id: 12,
                        month: 'December',
                        accountNumber: ''
                    }
                ]
            }
        },
        addNewYear() {
            this.yearlyAccounts.push(this.getDefaultData())
        },
        removeYear(index) {
            this.yearlyAccounts.splice(index, 1)
        },
        getYearlyAccounts() {
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}settings/monthly-accounts`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.success && response.data) {
                    this.yearlyAccounts = response.data.setting_meta_data
                }
                this.$store.dispatch('setLoadStatus')
            });
        },
        updateMonthlyAccounts() {
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}settings/monthly-accounts/update`, {
                method: 'POST',
                body: JSON.stringify({
                    setting_meta_data:this.yearlyAccounts
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.success) {
                    console.log(response);
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                }
                this.$store.dispatch('setLoadStatus')
            })
            .catch(error => {
                console.error('Error:', error);
                this.$notify({
                    type: 'error',
                    title: 'An error occurred while updating monthly accounts.'
                });
            });
        },
    },    
}
</script>

<style lang="scss" scoped>

</style>